<template>
  <ThankYouPage />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ThankYouPage from 'chimera/all/themes/blueflow/page/ThankYou/ThankYouPage'

export default {
  components: {
    ThankYouPage,
  },

  extends: AbstractPage,

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Muchas gracias por su solicitud!',
      headDescription:
        'Introduce tu codigo postal y compara gratis hasta 6 empresas de tu provincia. El mejor precio para tu proveedor de paneles solares. Ahorra hasta un 40%. 100% Gratis.',
      path: '/solicitudes-de-cotizacion/solicitud-completada',
    }
  },
}
</script>
